const $ = require('jquery');
window.jQuery = $;
require('./jquery.ui/ui/jquery-ui.custom');
